import React, { useState, useEffect, useContext } from 'react'
import { withRouter, Link as RouterLink } from 'react-router-dom'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { getContentRecord, fetchContentRecord, getContentIndex, fetchContentIndex } from 'alpha-js'

import { withStyles } from '@material-ui/core/styles'

import { NavigationContext } from '../ui/NavigationController'

import PageMenu from './PageMenu'

import Container from '@material-ui/core/Container'
import Fade from '@material-ui/core/Fade'
import Drawer from '@material-ui/core/Drawer'
import Link from '@material-ui/core/Link'
import Box from '@material-ui/core/Box'
import AppBar from '@material-ui/core//AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import MenuIcon from '@material-ui/icons/Menu'
import IconButton from '@material-ui/core/IconButton'
import Button from '@material-ui/core/Button'
import Badge from '@material-ui/core/Badge'
import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer'
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart'
import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import CollectionsIcon from '@material-ui/icons/Collections'
import HomeIcon from '@material-ui/icons/Home'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import ListSubheader from '@material-ui/core/ListSubheader'

import Markdown from '../ui/Markdown'

import useMediaQuery from '@material-ui/core/useMediaQuery'

const styles = theme => ({
  root: {
    position: 'fixed',
    zIndex: 100,
  },
  title: {
    fontSize: 24,
  },
  placeholder: {
    height: 56,
    [theme.breakpoints.up('sm')]: {
      height: 70,
    },
  },
  appbar: {
//    color: theme.palette.common.black,
//    backgroundColor: theme.palette.common.white,
    background: 'transparent'
  },
  appbarBackground: {
    position: 'fixed',
    width: '100%',
    height: 56,
    [theme.breakpoints.up('sm')]: {
      height: 70,
    },
  },
  appbarPlaceholder: {
    height: 56,
    [theme.breakpoints.up('sm')]: {
      height: 74,
    },
  },
  toolbar: {
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 56,
    [theme.breakpoints.up('sm')]: {
      height: 70,
    },
  },
  logoBox: {
    paddingTop: theme.spacing.unit/2,
  },
  logo: {
    maxHeight: 36,
    [theme.breakpoints.up('sm')]: {
      maxHeight: 40
    }
  },
  left: {
    flex: 1,
  },
  leftGrow: {
  },
  leftLinkActive: {
//    color: theme.palette.common.white,
  },
  right: {
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end',
  },
  rightLink: {
    fontSize: 16,
//    color: theme.palette.common.white,
    marginLeft: theme.spacing(3),
  },
  linkSecondary: {
    color: theme.palette.secondary.main,
  },
  menuButton: {
//    marginLeft: 12,
//    marginRight: 12,
  },
  menuButtonHidden: {
    display: 'none',
  },
  desktopHidden: {
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    }
  },  
  mobileHidden: {
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    }
  },
  cardImage: {
    width: '100%',
  },
  
});

const HeaderMenuCard = ({ classes, theme, body, images }) => {

  let imageUrl = null
  if (images && images !== undefined && images.length > 0) {
    imageUrl = images[0].image_url
    if (imageUrl.startsWith("/"))
      imageUrl = "http://178.128.86.10:8000" + imageUrl
  }

  return (
  <>
    { imageUrl &&
      <Box mb={1}>
        <img src={imageUrl} className={classes.cardImage} />
      </Box>
    }
    { body &&
      <Box>
        <Markdown source={ body } />
      </Box>
    }
  </>
  )
}

const HeaderMenu = ({ classes, history, theme, items, variant='List', onClick }) => {

  if (variant == 'Card') {
    let itemsPerRow = 4
    let spacing = 4
    return (
      <Grid container spacing={spacing}>
      { items.map((item) => (
        <Grid item xs={12/itemsPerRow}>
          <Box display='flex' flexDirection='column' onClick={()=>onClick(item)}>
            <HeaderMenuCard classes={classes} theme={theme} {...item}
            /> 
          </Box>
        </Grid>
        )) 
      }
      </Grid>
      
    )
  }
  else if (!variant || variant == 'List')
    return (
      <Box style={{ width: 400 }}>
        <List style={{padding: 0}}>
        { items.map((item) =>
          <ListItem 
            onClick={() => onClick(item)}>          
            <ListItemText
              primary={
              <Typography variant='h5' className={classes.linkText}>
              { item.button_title }
              </Typography>
              } 
            />          
          </ListItem>
          )
        }
        </List>
      </Box>
    )
}

const Header = ({ classes, path, history, theme, business, inboxStats, headerPage, fetchHeaderPage, pageList, fetchPageList, dark=false }) => {

  const navigationContext = useContext(NavigationContext)

  const [isDrawerOpen, showDrawer] = useState(false)
  const [transparentBar, setTransparentBar] = useState(true)
  
  const updateStyleOnScroll = () => {
    if (window.pageYOffset > 0) {
      if (transparentBar)
        setTransparentBar(false)
    }
    else if (!transparentBar)
      setTransparentBar(true)
  }
  
  useEffect(() => {
    fetchPageList()
    fetchHeaderPage()
  }, [])
  
  useEffect(() => {
    // This must be called on every render, otherwise updateStyleOnScroll won't be called
    window.addEventListener("scroll", updateStyleOnScroll);      
  })
    
  let menuList = []
  if (headerPage.lastFetched && headerPage.data.sections !== undefined) {
    menuList = [
/*
      {
        'button_title': 'Home',
        'link_to': '/'
      },
*/
      ...headerPage.data.sections.filter((s) => s.component == 'HeaderMenu'),
    ]
  }
  else if (pageList.lastFetched) {
    let allPages = pageList.data.records.reduce((p, n) => {
      if (n.component == 'Header' || n.component == 'Footer')
        return p
      if ('menu_index' in n && n['menu_index'] != "" && parseInt(n['menu_index']) >= 0)
        return [...p, {
          button_title: n.title,
          link_to: '/' + n.key,
          menu_index: parseInt(n['menu_index'])
        }]
      else
        return p
    }, [])
    
    let sortedPages = allPages.sort((a, b) => {
      if (a['menu_index'] > b['menu_index'])
        return 1
      if (a['menu_index'] < b['menu_index'])
        return -1
      return 0
      })

/*
    menuList.push({
      'button_title': 'Home',
      'link_to': '/'
    })

    menuList.push({
      'button_title': 'Blog',
      'link_to': '/blog'
    })
*/

/*
    
    if (allPages.length > 3)
      menuList.push({
        'button_title': 'Pages',
        'items': allPages
        })
    else
      menuList.push(...allPages)            
*/

    menuList.push(...sortedPages)
  }
  
  const [selectedMenuIndex, setSelectedMenuIndex] = useState(-1)
  
  const openMenuItem = (item) => {
    setSelectedMenuIndex(-1)
    if (item.link_to) {
      if (item.link_to.startsWith("/"))
        history.push(item.link_to)
      else
        history.push("/" + item.link_to)
    }
  }
  
  let activeMenuIndex = -1
  for (var menuIndex = 0; menuIndex < menuList.length; menuIndex++) {
    let menu = menuList[menuIndex]
    if ('link_to' in menu) {
      if (path == '/') {      
        if (menu.link_to == '/') {
          activeMenuIndex = menuIndex
          break
        }
      }
      else if (menu.link_to != '/') {
        if (path.startsWith(menu.link_to)) {
          activeMenuIndex = menuIndex
          break
        }
      }
    }
  }

  let appbarStyle = {}
  let appbarBackgroundStyle = {}

  // TODO: use background color from section color and overlay attribute
  appbarStyle['backgroundColor'] = 'rgba(255, 255, 255, 1.0)'

  if (transparentBar && selectedMenuIndex == -1) {
    if (dark)
      appbarStyle['color'] = theme.palette.common.white
    else
      appbarStyle['color'] = '#555'
    appbarBackgroundStyle = {
      background: 'transparent'
    }
  }
  else {
    appbarStyle['color'] = theme.palette.primary.main
    appbarBackgroundStyle = {
      backgroundColor: theme.palette.common.white,
    }
  }
  
  /*
  let cartIcon = (
    <ShoppingCartIcon />
    )
  if (cart && cart.lastUpdate && cart.data.lines.length)
    cartIcon = (
      <Badge badgeContent={ cart.data.lines.length } color="secondary">
        { cartIcon }
      </Badge>
    )
  */
    
  let inboxIcon = (
    <QuestionAnswerIcon />
    )
  if (inboxStats && inboxStats !== undefined && inboxStats.new_count !== undefined && inboxStats.new_count > 0)
    inboxIcon = (
      <Badge badgeContent={ inboxStats.new_count } color="secondary">
        { inboxIcon }
      </Badge>
    )
  
  /*
  let userIcon = (
    <AccountCircleIcon />
    )
  if (orderList && orderList.lastFetched && orderList.data.count)
    userIcon = (
      <Badge badgeContent={ orderList.data.count } color="secondary">
        { userIcon }
      </Badge>
    )
  */
    
  let smUp = useMediaQuery(theme.breakpoints.up('sm'))      

  /*
  const openChat = (key) => {
    if (key == -1) {
      if (smUp)
        navigationContext.showSideContent(
            <Inbox />
          )      
      else
        history.push("/inbox")
      return
    }
  
//    history.push("/inbox")  
//      navigationContext.showSideContent(
//                <Inbox />
    navigationContext.showPopupContent(
      <Chat conversationKey={key} openChat={ openChat } />
      )
  }
  */
  
  if (headerPage.isFetching)
    return (
    <div className={classes.root}>
      <AppBar position="fixed" className={classes.appbar} style={appbarStyle} elevation={0}>
      </AppBar>
    </div>
    )
      
  let variant = headerPage.lastFetched ? headerPage.data.variant : 'Center'
  
  let isInboxPage = path.startsWith("/inbox")
  
  let notificationIcons = (
    <>
      <IconButton color='inherit' 
        onClick={() => openChat(-1)}
        >
        { inboxIcon }
      </IconButton>
    </>)
  notificationIcons = (<></>)
    
  if (smUp) {
  
    // Note: If I use borderBottom style, it work on first load, but on navigate
    // to other page, border color will back to standard black color. But if I add it
    // to borderBottom style, it works well.
    let activeBorderStyle = "3px solid " + theme.palette.primary.main
  
    let menuItems = (
      <>
        { menuList.length && menuList.map((m, index) =>
          <Box style={{ display: 'inline', paddingTop: '6px', paddingBottom: '6px', borderBottom: activeMenuIndex == index ? activeBorderStyle : "none" }}>
            <Button className={classes.mobileHidden}
              style={{ fontWeight: 800 }}
              color={ selectedMenuIndex == index || true ? 'standard' : 'inherit' }
              onClick={() => {
                if (selectedMenuIndex == index)
                  setSelectedMenuIndex(-1)                    
                else if (m.items && m.items !== undefined && m.items.length)
                  setSelectedMenuIndex(index)
                else if (m.link_to && m.link_to !== undefined)
                  openMenuItem(m)
              }}>
              { m.button_title }
            </Button>
          </Box>
          )
          .reduce((prev, next) =>
            [ prev,
              <Typography style={{ fontSize: "0.9em", opacity: "0.5" }} component="span">&nbsp;</Typography>
              , next
            ])
        }
      </>)    
    
  
    let toolbar = null
    if (variant == 'Left')
      // Left logo and menu, right notification bar
      toolbar = (
        <Toolbar className={classes.toolbar}>
          <Box className={classes.logoBox} mr={4}>
            <a onClick={() => history.push("/")}>
            { 'logo' in business &&
              <img src={business.logo.image_url} className={classes.logo}/>          
            }
            </a> 
          </Box>
          <div className={classes.leftGrow}>
            { menuItems }
          </div>          
          <div className={clsx(classes.right)}>
            { notificationIcons }
          </div>
        </Toolbar>      
      )
    else    
      // Center logo, left menu, right notification bar
      toolbar = (
        <Toolbar className={classes.toolbar}>
          <div className={classes.left}>
            { menuItems }
          </div>
          
          <Box className={classes.logoBox}>
            <a onClick={() => history.push("/")}>
            { 'logo' in business &&            
              <img src={business.logo.image_url} className={classes.logo}/>          
            }
            </a> 
          </Box>
          <div className={clsx(classes.right)}>
            { notificationIcons }
          </div>
        </Toolbar>      
      )
      
    return (
      <div className={classes.root}>
        <AppBar position="fixed" className={classes.appbar} style={appbarStyle} elevation={0}>
          <Fade in={!transparentBar || selectedMenuIndex >= 0}>
            <Box className={classes.appbarBackground} style={appbarBackgroundStyle}>                                
            { selectedMenuIndex >= 0 &&
            <>
              <Box className={classes.appbarPlaceholder} />
              <Container style={appbarBackgroundStyle}>
                <HeaderMenu classes={classes} theme={theme}
                  onClick={(item)=> openMenuItem(item)}
                  {...menuList[selectedMenuIndex]}
                />
              </Container>
            </>
            }          
            </Box>          
          </Fade>
          <Container style={{ padding: 0 }}>
            { toolbar }
          </Container>
        </AppBar>
        <div className={classes.placeholder} />
      </div>
    )
  }
  else {
  
    let toolbar = null
    if (variant == 'Left')
      toolbar = (
      <>
        <Box className={classes.logoBox} mr={4}>
          <a onClick={() => history.push("/")}>
            { 'logo' in business &&
            <img src={business.logo.image_url} className={classes.logo}/>
            }
          </a> 
        </Box>      
        <div className={clsx(classes.right)}>
          { notificationIcons }
          <IconButton
            color="inherit"
            aria-label="Open drawer"
            onClick={() => showDrawer(!isDrawerOpen)}
            className={clsx(
              classes.menuButton,
              isDrawerOpen && classes.menuButtonHidden,
              classes.desktopHidden
            )}
          >
            <MenuIcon />
          </IconButton>
        </div>
      </>
      )
    else
      toolbar = (
      <>
        <div className={classes.left}>
          <IconButton
            color="inherit"
            aria-label="Open drawer"
            onClick={() => showDrawer(!isDrawerOpen)}
            className={clsx(
              classes.menuButton,
              isDrawerOpen && classes.menuButtonHidden,
              classes.desktopHidden
            )}
          >
            <MenuIcon />
          </IconButton>
        </div>
        
        <Box className={classes.logoBox}>
          <a onClick={() => history.push("/")}>
            { 'logo' in business &&
            <img src={business.logo.image_url} className={classes.logo}/>          
            }
          </a> 
        </Box>        
        <div className={clsx(classes.right)}>
          { notificationIcons }
        </div>
      </>
      )
  
    // Mobile view.
    return (
      <div className={classes.root}>
        <AppBar position="fixed" className={classes.appbar} style={appbarStyle} elevation={0}>
          <Fade in={!transparentBar}>
            <Box className={classes.appbarBackground} style={appbarBackgroundStyle}>                                
            </Box>          
          </Fade>
          <Container style={{ padding: 0 }}>
            <Toolbar className={classes.toolbar}>
              { toolbar }
            </Toolbar>
          </Container>
        </AppBar>
        <div className={classes.placeholder} />
        <Drawer open={isDrawerOpen} onClose={() => showDrawer(false)}>
          <div
            onClick={() => showDrawer(false)}
            onKeyDown={() => showDrawer(false)}
          >
            <PageMenu hideMenu={() => showDrawer(false)} />
          </div>
        </Drawer>      
      </div>
    )
  }
}

Header.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  return { 
    headerPage: getContentRecord(state, "page", "header"),
    pageList: getContentIndex(state, 'page', 'default'),
    path: ownProps.location.pathname,
    inboxStats: state.alpha.conversationList.stats,
  }
} 

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchHeaderPage: () => {
      dispatch(fetchContentRecord('page', 'header'))
    },
    fetchPageList: (refresh=false) => {
      dispatch(fetchContentIndex('page', 'default', null, refresh))
    },
  }
}

export default withRouter(
  withStyles(styles, { withTheme: true })(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(Header)
  )
)
